import React from 'react';
import { Heading, View } from '@smarterservices/smarter-ui';
import { BlockComponentProps, HeadingBlock as HeadingBlockType } from '../../types';

/**
 * HeadingBlock component renders a heading with specified level
 * 
 * @param {BlockComponentProps<HeadingBlockType>} props - Component props
 * @returns {React.ReactElement} Rendered heading
 */
export const HeadingBlock = ({ block }: BlockComponentProps<HeadingBlockType>) => {
  const validLevel = Math.min(6, Math.max(1, block.level));
  return (
    <View as="div" textAlign={block.textAlign} margin={block.margin || "none"}>
    <Heading 
      level={`h${validLevel}` as 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6'} 
    >
      {block.text}
    </Heading>
    </View>
  );
};

export default HeadingBlock;
